import { useState } from 'react'
import { LandingNav } from './components/LandingNav'
import { HeroSection } from './components/HeroSection'
import { StatsCounter } from './components/StatsCounter'
import { FeatureShowcase } from './components/FeatureShowcase'
import { TestimonialsSection } from './components/TestimonialsSection'
import { LeagueBadges } from './components/LeagueBadges'
import { BookmakerGrid } from './components/BookmakerGrid'
import { PricingSection } from './components/PricingSection'
import { FAQSection } from './components/FAQSection'
import { FinalCTASection } from './components/FinalCTASection'
import { LandingFooter } from './components/LandingFooter'
import { ComingSoonModal } from './components/ComingSoonModal'

export default function LandingPage() {
  const [showComingSoon, setShowComingSoon] = useState(false)

  const openComingSoon = () => setShowComingSoon(true)
  const closeComingSoon = () => setShowComingSoon(false)

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <div className="landing-page">
      <LandingNav
        onCTAClick={openComingSoon}
        onNavClick={scrollToSection}
      />

      <HeroSection onCTAClick={openComingSoon} />

      <StatsCounter />

      <div id="features">
        <FeatureShowcase />
      </div>

      <TestimonialsSection />

      <LeagueBadges />

      <BookmakerGrid />

      <div id="pricing">
        <PricingSection onCTAClick={openComingSoon} />
      </div>

      <div id="faq">
        <FAQSection />
      </div>

      <FinalCTASection onCTAClick={openComingSoon} />

      <LandingFooter onNavClick={scrollToSection} />

      {showComingSoon && (
        <ComingSoonModal onClose={closeComingSoon} />
      )}
    </div>
  )
}
